export class ExportTypeLabelConstants {
    static PDF = "PDF";
    static Excel = "Excel";
    static Word = "Word";
}
